import { WishlistsType } from 'b2b-common/core/account/api/wishlists';
import {
  CLEAR_ACCOUNT_WISHLISTS,
  FETCH_WISHLISTS,
  FETCH_WISHLISTS_FULFILLED,
  FETCH_WISHLISTS_REJECTED,
} from './actionTypes';
import {
  ClearAccountWishlistsAction,
  FetchWishlistsAction,
  FetchWishlistsFulfilledAction,
  FetchWishlistsRejectedAction,
} from './types';

export const fetchWishlists = (pageSize: number, startItem: number): FetchWishlistsAction => ({
  type: FETCH_WISHLISTS,
  payload: {
    pageSize,
    startItem,
  },
});

export const fetchWishlistsFulfilled = (response: WishlistsType): FetchWishlistsFulfilledAction => ({
  type: FETCH_WISHLISTS_FULFILLED,
  payload: {
    data: response,
  },
});

export const fetchWishlistsRejected = (error: ErrorType): FetchWishlistsRejectedAction => ({
  type: FETCH_WISHLISTS_REJECTED,
  payload: {
    error,
  },
});

export const clearAccountWishlists = (): ClearAccountWishlistsAction => ({
  type: CLEAR_ACCOUNT_WISHLISTS,
});
